/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs */

const en_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Free use of 20 trees</span> updated every season</span>`)
};

const ar_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">استخدام مجاني لـ 20 شجرة</span> يتم تحديثها كل موسم</span>`)
};

const de_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Kostenlose Nutzung von 20 Bäumen</span> jede Saison aktualisiert</span>`)
};

const es_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Uso gratuito de 20 árboles</span> actualizados cada temporada</span>`)
};

const fr_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">20 arbres à utiliser gratuitement</span> mis à jour chaque saison</span>`)
};

const it_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Uso gratuito di 20 alberi</span> aggiornato ogni stagione</span>`)
};

const ja_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">シーズンごとに更新される<span style="[%2$s]">20本の樹種を無料で使用</span></span>`)
};

const ko_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">매 시즌마다 <span style="[%2$s]">무료 나무 20종</span> 업데이트</span>`)
};

const pt_br_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Uso gratuito de 20 árvores</span> atualizadas a cada temporada</span>`)
};

const ru_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Бесплатное использование 20 растений,</span> обновляемых каждый сезон</span>`)
};

const th_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">การใช้ต้นไม้ฟรี 20 ต้น</span> อัปเดตทุกฤดูกาล</span>`)
};

const tr_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Her mevsim güncellenen <span style="[%2$s]">20 ağacın ücretsiz kullanımı</span></span>`)
};

const zh_cn_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">每季<span style="[%2$s]"> 20 种树随你用</span></span>`)
};

const zh_tw_subscription_walkthrough_p1_content_seasonal_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">每季<span style="[%2$s]"> 20 種樹隨你用</span></span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\"><span style=\"[%2$s]\">Free use of 20 trees</span> updated every season</span>" |
*
* @param {Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_content_seasonal_tree = /** @type {((inputs?: Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Content_Seasonal_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_content_seasonal_tree(inputs)
	return zh_tw_subscription_walkthrough_p1_content_seasonal_tree(inputs)
});